module.exports = __webpack_public_path__ + "img/logo.ef2fe362.png";